import {
    createNativeStackNavigator
} from "@react-navigation/native-stack";
import AnnouncementRouter from "../../pages/common/announcementRouter";
import FormRouter from "../../pages/common/formRouter";
import NewsRouter from "../../pages/common/newsRouter";
import ThreeT from "../../pages/common/threeT";
import Home from "../../pages/common/home";

const Stack = createNativeStackNavigator();

const CommonStack = () => {
    return <Stack.Navigator
        initialRouteName="Home"
    >
        <Stack.Screen
            name="Home"
            component={Home}
            options={{
                headerShown: false
            }}
        />
        <Stack.Screen
            options={{
                presentation: "transparentModal",
                headerShown: false,
                animation: "none"
            }}
            component={AnnouncementRouter}
            name="AnnouncementRouter"
        />
        <Stack.Screen
            options={{
                presentation: "transparentModal",
                headerShown: false,
                animation: "none"
            }}
            component={NewsRouter}
            name="NewsRouter"
        />
        <Stack.Screen
            options={{
                presentation: "transparentModal",
                headerShown: false,
                animation: "none"
            }}
            component={FormRouter}
            name="FormRouter"
        />

        <Stack.Screen
            component={ThreeT}
            name="ThreeT"
        />
    </Stack.Navigator>;
};
export default CommonStack;
